import { render, staticRenderFns } from "./VisitorList.vue?vue&type=template&id=495fddb5&scoped=true&"
import script from "./VisitorList.vue?vue&type=script&lang=js&"
export * from "./VisitorList.vue?vue&type=script&lang=js&"
import style0 from "./VisitorList.vue?vue&type=style&index=0&id=495fddb5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495fddb5",
  null
  
)

export default component.exports